import React, { useState, useEffect, useRef } from 'react';
import {
  Select,
  MenuItem,
  Typography,
  Box,
  FormControl,
  Tooltip,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { resolveFieldsService } from '../../apis/EntitiesSelection';
import { fetchSqlTableFields, getConnectionById } from '../../apis/Connections';

function RegistryFunc({
  selectedFields,
  workflowId,
  updatedConfig,
  sourceField,
  setSourceField,
  sourceEntity,
  setSourceEntity,
  selectedEntities,
  destRefEntity,
  setDestRefEntity,
  regisrtyField,
  setRegisrtyField,
  // relationFields,
  // setRelationFields,
  sourceFieldReference,
  setSourceFieldReference,
  selectedFieldName,
  setSelectedFieldName,
  hasSavedRegistry,
}) {
  const [sourceReferenceFields, setSourceReferenceFields] = useState([]);
  const [regisrtyFields, setRegisrtyFields] = useState([]);
  const didAutofillRef = useRef(false);
  // Check both node.type and node.config.type for compatibility with SQL nodes
  const destinationNode = updatedConfig?.nodes?.find(
    (node) =>
      node?.type === 'destinationNode' ||
      node?.type === 'destination' ||
      node?.config?.type === 'destinationNode' ||
      node?.config?.type === 'destination',
  );
  useEffect(() => {
    if (selectedFields?.length > 0 && !sourceField) {
      setSourceField(selectedFields[0]); // ✅ it's a string now
    }
    if (selectedEntities?.length > 0 && !sourceEntity) {
      setSourceEntity(selectedEntities[0]); // ✅ it's a string now
    }
  }, [selectedFields, selectedEntities, sourceField, sourceEntity]);

  const destinationKey = `${destinationNode.id}-${
    destinationNode?.config?.connection?.conn_id || ''
  }-${destinationNode?.config?.module || ''}`;
  const entitiesByWorkflow = useSelector(
    (state) => state.entities.entitiesByWorkflow,
  );
  const finalConfigPayload = useSelector(
    (state) => state.mapping.finalConfigPayloadByWorkflow?.[workflowId],
  );
  console.log('conn finalConfigPayload:', finalConfigPayload);
  const destEntityList =
    entitiesByWorkflow?.[workflowId]?.[destinationKey] || [];

  const resolvedData = useSelector(
    (state) => state.mapping.resolvedFieldsByWorkflow?.[workflowId],
  );

  const renderBy = (options) => (val) => {
    if (!val) return '';
    const hit = options.find((o) => o.value === val);
    return hit ? hit.label : String(val);
  };

  const uniqByValue = (arr) => {
    const map = new Map();
    arr.forEach((o) => {
      if (o?.value) map.set(o.value, o);
    });
    return [...map.values()];
  };

  const destRefEntityOptions = (destEntityList || []).map((e) => ({
    value: e.entity_name, // backend ID
    label: e.label || e.entity_name, // UI label fallback
  }));

  const MENU_PROPS = {
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
    transformOrigin: { vertical: 'top', horizontal: 'left' },
    marginThreshold: 0,
    PaperProps: {
      sx: {
        maxHeight: 240,
        mt: 0.5,
        minWidth: 0,
        width: '200px',
      },
    },

    MenuListProps: {
      dense: true,
      sx: { py: 0 },
    },
  };

  const StyledSelect = styled(Select)({
    width: '100%',
    fontSize: '0.938rem',
    borderRadius: '4px',
    '& .MuiOutlinedInput-root': {
      height: '40px', // Set fixed height
      borderRadius: '4px',
      paddingRight: '32px', // Ensure space for dropdown icon
    },
    '& .MuiSelect-select': {
      padding: '7px 12px',
      display: 'flex',
      alignItems: 'center',
      fontSize: '0.938rem',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.5)',
    },
  });

  // useEffect(() => {
  //   if (!selectedEntities?.length || !resolvedData?.length) {
  //     setSourceReferenceFields([]);
  //     setSelectedFieldName([]);
  //     return;
  //   }

  //   const entityNamesLower = selectedEntities
  //     .map((ent) =>
  //       (typeof ent === 'string' ? ent : ent?.entity_name)?.toLowerCase()
  //     )
  //     .filter(Boolean);

  //     console.log('registry resolvedData', resolvedData)
  //   const allFieldOptions = resolvedData
  //     .filter(
  //       (node) =>
  //         (node.type === 'source' || node.type === 'sourceNode') &&
  //         entityNamesLower.includes(node?.fields?.entity_name?.toLowerCase())
  //     )
  //     .flatMap((node) => node?.fields?.fields || []).filter((f) => f?.data_type === 'reference')
  //     .map((f) => ({
  //       value: f.field_name || f.field_label, // backend ID
  //       label: f.field_label || f.field_name, // UI label
  //     }))
  //     .filter(
  //       (o) => typeof o.value === 'string' && typeof o.label === 'string'
  //     );

  //   const selectedFieldSet = new Set(
  //     (selectedFields || []).map((s) => s?.toLowerCase()).filter(Boolean)
  //   );

  //   const selectedFieldNames = allFieldOptions
  //     .filter((o) => selectedFieldSet.has(o.label.toLowerCase()))
  //     .map((o) => o.value);

  //   setSelectedFieldName(selectedFieldNames);

  //   // ✅ Show ALL options (no exclusion), still de-duped by value
  //   setSourceReferenceFields(uniqByValue(allFieldOptions));
  // }, [selectedEntities, resolvedData, selectedFields]);

  useEffect(() => {
    if (!selectedEntities?.length || !resolvedData?.length) {
      setSourceReferenceFields([]);
      setSelectedFieldName([]);
      return;
    }

    const entityNamesLower = selectedEntities
      .map((ent) =>
        (typeof ent === 'string' ? ent : ent?.entity_name)?.toLowerCase(),
      )
      .filter(Boolean);

    const allFieldOptions = resolvedData
      .filter(
        (node) =>
          (node.type === 'source' || node.type === 'sourceNode') &&
          entityNamesLower.includes(node?.fields?.entity_name?.toLowerCase()),
      )
      .flatMap((node) => node?.fields?.fields || [])
      // .filter((f) => f?.data_type === 'reference')
      .map((f) => ({
        value: f.field_name || f.field_label,
        label: f.field_label || f.field_name,
      }))
      .filter(
        (o) => typeof o.value === 'string' && typeof o.label === 'string',
      );

    const selectedFieldSet = new Set(
      (selectedFields || []).map((s) => s?.toLowerCase()).filter(Boolean),
    );

    const selectedFieldNames = allFieldOptions
      .filter((o) => selectedFieldSet.has(o.label.toLowerCase()))
      .map((o) => o.value);

    setSelectedFieldName(selectedFieldNames);

    const deduped = uniqByValue(allFieldOptions);
    setSourceReferenceFields(deduped);

    // 🔒 If a saved config exists, never auto-fill (don’t care if options arrived yet)
    if (hasSavedRegistry) {
      didAutofillRef.current = true;
      return;
    }

    // ✅ First-time prefill only (no saved value, field empty)
    if (!didAutofillRef.current && !sourceFieldReference) {
      const firstMatch = selectedFieldNames[0];
      if (firstMatch) setSourceFieldReference(firstMatch);
      didAutofillRef.current = true;
    }
  }, [selectedEntities, resolvedData, selectedFields, hasSavedRegistry]); // eslint-disable-line

  console.log('selectedFieldName:', selectedFieldName);

  // Helper function to check if config is SQL
  const isSqlConfig = (config) => {
    const connector =
      config?.connection?.connector_name ||
      config?.connection?.connector ||
      config?.label ||
      '';
    return (
      typeof connector === 'string' && connector.toLowerCase().includes('sql')
    );
  };

  // Helper function to get SQL metadata
  const getSqlMetadata = async (config) => {
    if (!config?.connection?.conn_id) return null;
    try {
      const connection = await getConnectionById(config.connection.conn_id);
      const params = connection?.custom_params || {};
      const token =
        params.token || params.quick_test_token || connection?.token || null;
      return token ? { token } : null;
    } catch (err) {
      console.error('Failed to get SQL metadata:', err);
      return null;
    }
  };

  // Helper function to normalize SQL fields response
  const normalizeSqlFields = (response) => {
    if (!response) return [];
    const candidates =
      response.fields?.fields ||
      response.fields ||
      response.columns ||
      response.schema ||
      response.data ||
      response.result ||
      response;
    const fields = Array.isArray(candidates) ? candidates : [];
    return fields
      .map((field) => {
        if (!field || typeof field !== 'object') return null;
        const fieldName =
          field.field_name ||
          field.column_name ||
          field.name ||
          field.columnName ||
          '';
        if (!fieldName) return null;
        const label =
          field.field_label ||
          field.display_name ||
          field.column_label ||
          field.column_name ||
          field.name ||
          fieldName;
        return {
          field_name: fieldName,
          field_label: label,
        };
      })
      .filter(Boolean);
  };

  const handleRelationFieldChange = (e) => {
    setRegisrtyField(e.target.value);
  };
  const handleRelationEntityChange = async (e = null) => {
    const selected = e ? e.target.value : destRefEntity; // Use the event value or the current destRefEntity value // const selected = e.target.value; // entity_name
    setDestRefEntity(selected);
    setRegisrtyField('');

    const enrichedPayload = Object.values(finalConfigPayload)
      .filter((n) => n.type === 'destination' || n.type === 'destinationNode')
      .map((n) => ({
        ...n,
        selectedEntities: [{ entity_name: selected, label: selected }],
      }));

    if (selected && enrichedPayload.length) {
      try {
        // Separate SQL and non-SQL configs
        const sqlConfigs = enrichedPayload.filter(isSqlConfig);
        const nonSqlConfigs = enrichedPayload.filter(
          (cfg) => !isSqlConfig(cfg),
        );

        let fieldOptionsRaw = [];

        // Handle non-SQL configs (e.g., Salesforce)
        if (nonSqlConfigs.length > 0) {
          const response = await resolveFieldsService({
            label: 'FieldResolution',
            configs: nonSqlConfigs,
          });
          fieldOptionsRaw = Array.isArray(response)
            ? response[0]?.fields?.fields || []
            : [];
        }

        // Handle SQL configs
        if (sqlConfigs.length > 0) {
          const sqlConfig = sqlConfigs[0]; // Use first SQL config
          const metadata = await getSqlMetadata(sqlConfig);
          if (metadata?.token) {
            const sqlResponse = await fetchSqlTableFields(
              metadata.token,
              selected,
            );
            const sqlFields = normalizeSqlFields(sqlResponse);
            fieldOptionsRaw = [...fieldOptionsRaw, ...sqlFields];
          }
        }

        console.log('registry response:', fieldOptionsRaw);
        const fieldOptions = fieldOptionsRaw
          // .filter((f) => f?.data_type === 'reference')
          .map((f) => ({
            value: f.field_name || f.field_label, // backend ID
            label: f.field_label || f.field_name, // UI label
          }))
          .filter((o) => typeof o.value === 'string');

        setRegisrtyFields(fieldOptions);
        // if (fieldOptions.length) setRelationField(fieldOptions[0].value);
        if (!regisrtyField && fieldOptions.length) {
          setRegisrtyField(fieldOptions[0].value);
        } else if (
          regisrtyField &&
          fieldOptions.some((option) => option.value === regisrtyField)
        ) {
          // If referenceField already has a value that exists in fieldOptions, retain it
          // Otherwise, set it to the first field option
          setRegisrtyField(regisrtyField);
        } // Set the first field as the default
      } catch (err) {
        console.error('Failed to fetch registry fields:', err);
        setRegisrtyFields([]);
      }
    } else {
      setRegisrtyFields([]);
    }
  };

  useEffect(() => {
    if (destRefEntity) {
      handleRelationEntityChange(); // Call the function even when referenceEntity has a value
    }
  }, [destRefEntity]);

  return (
    <>
      <Box mt={1}>
        {/* Source Relation Field */}
        <FormControl fullWidth margin="normal">
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Source Reference Field
          </Typography>
          {/* Source Relation Field (value = field_name, show label) */}
          <StyledSelect
            value={sourceFieldReference}
            MenuProps={MENU_PROPS}
            onChange={(e) => setSourceFieldReference(e.target.value)}
            renderValue={renderBy(sourceReferenceFields)}
          >
            <MenuItem value="" disabled>
              Select
            </MenuItem>
            {sourceReferenceFields.map((opt) => (
              <MenuItem
                key={opt.value}
                value={opt.value}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {opt.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>

        {/* Relationship Entity */}
        <FormControl fullWidth margin="normal">
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Destination Reference Entity
          </Typography>
          {/* Relationship Entity (value = entity_name, show label) */}
          <StyledSelect
            value={destRefEntity}
            MenuProps={MENU_PROPS}
            onChange={handleRelationEntityChange}
            renderValue={renderBy(destRefEntityOptions)}
          >
            <MenuItem value="" disabled>
              Select
            </MenuItem>
            {destRefEntityOptions.map((opt) => (
              <MenuItem
                key={opt.value}
                value={opt.value}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {opt.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>

        {/* Relationship Field */}
        <FormControl fullWidth margin="normal">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Value
            </Typography>
            <Tooltip
              title="Field from selected destination Reference entity"
              arrow
            >
              <InfoOutlinedIcon
                sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help' }}
              />
            </Tooltip>
          </Box>
          {/* Relationship Field (value = field_name, show label) */}
          <StyledSelect
            value={regisrtyField}
            MenuProps={MENU_PROPS}
            // onChange={(e) => setRelationField(e.target.value)}
            onChange={handleRelationFieldChange}
            renderValue={renderBy(regisrtyFields)}
          >
            <MenuItem value="">Select</MenuItem>
            {regisrtyFields.map((opt) => (
              <MenuItem
                key={opt.value}
                value={opt.value}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {opt.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
      </Box>
    </>
  );
}

RegistryFunc.propTypes = {
  selectedFields: PropTypes.array,
  workflowId: PropTypes.string.isRequired,
  updatedConfig: PropTypes.object,
  sourceField: PropTypes.string,
  setSourceField: PropTypes.func,
  selectedEntities: PropTypes.array,
  destRefEntity: PropTypes.string,
  setDestRefEntity: PropTypes.func,
  regisrtyField: PropTypes.string,
  setRegisrtyField: PropTypes.func,
  sourceEntity: PropTypes.string,
  setSourceEntity: PropTypes.func,
  sourceFieldReference: PropTypes.string,
  setSourceFieldReference: PropTypes.func,
  selectedFieldName: PropTypes.array,
  setSelectedFieldName: PropTypes.func,
  hasSavedRegistry: PropTypes.bool,
};

export default RegistryFunc;
